'use client'

import React, { useState } from 'react'
import Image from 'next/image'
import styles from './styles.module.scss'
import CommsCard from '../CommsCard'
import CommsModal from '../CommsModal'

const ContactChannelBase = ({ isMobile, handleModalOpen, ...props }) => {
  const [modalContent, setModalContent] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleCtaClick = modalData => {
    setModalContent(modalData)
    setIsModalOpen(true)
    handleModalOpen(true)
  }
  const { heading, comms_cards: cards, support_Image: supportImg } = props?.contact_channel?.data?.attributes

  return (
    <div className={styles.contactWrapper}>
      <div className={styles.mainContent}>
        <h2 className={styles.heading}>{heading}</h2>
        <div className={styles.cardGroup}>
          {cards.data.map((card, idx) => (
            <CommsCard key={idx} data={card} onCtaClick={handleCtaClick} />
          ))}
        </div>
      </div>

      {supportImg?.data.attributes.url && (
        <div className={styles.supportImage}>
          <Image
            src={supportImg?.data.attributes.url}
            alt="Support Staff"
            width={supportImg?.data.attributes.width}
            height={supportImg?.data.attributes.height}
            objectFit="contain"
          />
        </div>
      )}

      <CommsModal
        show={isModalOpen}
        onHide={() => {
          setIsModalOpen(false)
          handleModalOpen(false)
        }}
        content={modalContent}
        isMobile={isMobile}
      />
    </div>
  )
}

export default ContactChannelBase
